<div [formGroup]="formGroup()" class="form-group">
  <finxone-input
    [id]="id()"
    [name]="name()"
    [formControlName]="formControlName()"
    [parentControl]="parentControl()"
    [label]="label() || ''"
    [type]="type()"
    [placeholder]="placeholder() || ''"
    [value]="formGroup().controls[formControlName()]?.value ?? ''"
    [showErrors]="true"
    [formControlInvalid]="
      !!(formGroup().get(formControlName())?.invalid && formGroup().get(formControlName())?.touched)
    "
    [validationConfig]="validationConfig()"
    [infoText]="infoText()"
    [isVerifyButtonShown]="isVerifyButtonShown() || false"
    [isVerifyButtonGlobalStylingAllowed]="isVerifyButtonGlobalStylingAllowed()"
    [verifyButtonGlobalStylingClass]="verifyButtonGlobalStylingClass()"
    [verifyButtonStyle]="verifyButtonStyle()"
    [verifyButtonTextContent]="verifyButtonTextContent()"
    [spaceBetweenElementUnit]="spaceBetweenElementUnit() || ''"
    [spaceBetweenElementValue]="spaceBetweenElementValue() || 0"
    (buttonClicked)="verifyEmail()"
    [disableAutocomplete]="disableAutocomplete()"
    [inputLabelTooltipText]="inputLabelTooltipText()"
  ></finxone-input>
</div>
